interface ServerConfig {
  readonly protocol: string;
  readonly host: string;
  readonly baseUrl: string;
}

function getServerConfig(): ServerConfig {
  const isDev = process.env.NODE_ENV === 'development';

  // In development, use empty baseUrl so requests go through webpack proxy
  if (isDev) {
    return {
      protocol: 'http',
      host: 'localhost:3000',
      baseUrl: '',
    };
  }

  // In production, use the Datex API
  return {
    protocol: 'https',
    host: 'api.datexcore.com',
    baseUrl: 'https://api.datexcore.com',
  };
}

export const serverConfig = getServerConfig();
